import {
  React,
  Component
} from 'imports/CommonImports';

import {
  Dialog,
  FlatButton
} from 'material-ui';

const styles = {
  actionsContainer: {
    display: 'flex',
    padding: '0',
  },
  buttonLabel: {
    color: '#FFFFFF',
  },
  contentContainer: {
    width: '35%',
  },
  centerText: {
    textAlign: 'center',
  },
  button: {
    borderRadius: '0',
    width: '50%'
  },
}
export default class AlertDialog extends Component {
  constructor(props){
    super(props);
    this.state = {
      open: true
    };
  }

  handleConfirm = () => {
    this.props.confirm();
    this.handleClose();
  };

  handleCancel = () => {
    this.props.cancel();
    this.handleClose();
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const actions = [
      <FlatButton
        label={this.props.cancelLabel}
        primary={true}
        onClick={this.handleCancel}
        backgroundColor='#ba0f0f'
        labelStyle={styles.buttonLabel}
        hoverColor='#eab6b8'
        style={styles.button}
      />,
      <FlatButton
        label={this.props.acceptLabel}
        primary={true}
        onClick={this.handleConfirm}
        backgroundColor='#11AB99'
        labelStyle={styles.buttonLabel}
        hoverColor='#89d6c7'
        style={styles.button}
      />,
    ];

    return (
      <div>
        <Dialog
          actions={actions}
          modal={true}
          open={this.state.open}
          actionsContainerStyle={styles.actionsContainer}
          contentStyle={styles.contentContainer}
        >
          <h2 style={styles.centerText}>{this.props.title || '¡Atención!'}</h2>
          <h3 style={styles.centerText}>{this.props.message}</h3>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/design/AlertDialog.js